import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronUp } from "lucide-react";

export const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          type="button"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.3 }}
          onClick={handleClick}
          className="fixed bottom-24 left-6 z-40 inline-flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-white/80 text-taupe shadow-soft backdrop-blur"
          aria-label="กลับขึ้นด้านบน"
          data-testid="back-to-top-button"
        >
          <ChevronUp className="h-5 w-5" data-testid="back-to-top-icon" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};